<template>
  <StickyTable :header="header" :data="data" class="progress-table" :annotations="annotations" :loading="busy">
    <template #header="{ item: { name, aggregatedValue } }">
      <tr>
        <Cell th horizontal vertical class="name">{{ name }}</Cell>
        <Cell th vertical v-for="(item, key) in aggregatedValue" :key="key">
          {{ item }}
        </Cell>
      </tr>
    </template>
    <template #row="{ item: { name, aggregatedValue }, annotation: { suffix, formatter }, index }">
      <tr :key="index">
        <Cell horizontal class="name">{{ name }}</Cell>
        <Cell v-for="(value, key) in aggregatedValue" :key="key">
          {{ formatter(value) }}<span class="suffix">{{ suffix }}</span>
        </Cell>
      </tr>
    </template>
  </StickyTable>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { numberFormat, rateFormat } from '@/utils/number'
import StickyTable, { Cell } from '@/components/molecules/StickyTable'

export default {
  name: 'ProgressTable',
  components: {
    StickyTable,
    Cell,
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      busy: state => state.analysis.progress.busy,
    }),
    ...mapGetters({
      header: 'analysis/progress/header',
      data: 'analysis/progress/data',
    }),
    annotations() {
      const number = { suffix: '人', formatter: numberFormat }
      const rate = { suffix: '%', formatter: rateFormat }
      return [number, number, rate, number, number, rate]
    },
  },
}
</script>

<style scoped lang="postcss">
.progress-table {
  max-height: 600px;

  td {
    min-width: 80px;
    padding: 0 16px;
    text-align: right;

    &.name {
      font-size: 13px;
      line-height: 1.3;
      text-align: left;
    }

    .suffix {
      font-size: 10px;
      margin-left: 2px;
    }
  }

  .name {
    left: 0;
  }
}
</style>
